import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-addordermode',
  templateUrl: './addordermode.component.html',
  styleUrls: ['./addordermode.component.css']
})
export class AddordermodeComponent implements OnInit {

  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;

  //Save Validation
  submitted: boolean;
  successfully: boolean;
  saveloading: boolean;


  //Edit Get Values
  ordermodeColl: any = [];
  ordermodeid: number = 0

  pricetypeColl: any = [];
  //pageColl:any=[];

  ordermodeform = new FormGroup({
    ordermodeid: new FormControl(0),
    ordermodename: new FormControl('', Validators.required),
    pricetypeid: new FormControl(null),
    inactive: new FormControl(false),
  });

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;
  formname: String = "Ordermode";


  @Input() ordermodename: any = '';
  @Output() emitData = new EventEmitter();

  constructor(private toastr: ToastrService, private appService: DhukanDataService, private route: ActivatedRoute,
    private loginService: LoginDataService, private activeModal: NgbActiveModal, private confirmationDialogService: ConfirmationDialogService) {
    this.route.queryParams.subscribe(params => {
      if (params.id !== undefined) {
        this.ordermodeid = params.id
      }
    });
    this.fnServiceChanges();
  }

  fnServiceChanges() {
    this.loginService.serviceloginChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
      if (this.loginService.fnCheckUser()) {

        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }         
      }
      else {
        this.fnUserFailedForm();
      }
    });
  }

  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
      if (this.loginService.fnCheckUser()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }
    }
    else {
      this.loginService.fnCompanyFaildRedirect();
    }         
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.ordermodeform.reset();
      this.fnInitializeOrdermode();

      if (this.ordermodeid > 0) {
        this.fngetOrdermode();
      }
      this.fngetPricetype();
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }



  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.ordermodeid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }

    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }


  fnInitializeOrdermode() {
    this.ordermodeform.setValue({

      ordermodeid: 0,
      ordermodename: '',
      pricetypeid:null,
      inactive:false,
    })
  }
  fngetPricetype() {
   
    var data = {
      'pricetypeid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getPricetype(data)
      .subscribe(
        (res) => {
          this.pricetypeColl = res.json().result;
         
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }
  //Get 
  fngetOrdermode() {
   
    var data = {
      'Ordermodeid': this.ordermodeid,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getOrdermode(data)
      .subscribe(
        (res) => {
          this.ordermodeColl = res.json().result;
          var editdata = this.ordermodeColl[0];
          this.fnEditMode(editdata);
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  //Save Btn Click
  fnSaveBtnClick() {
 
    try {
      if(this.saveloading){
        return
      }
      this.submitted = true;
      this.successfully = false;
      //Validate
      if (this.ordermodeform.valid) {
        this.saveloading=true
        //Check
        var data = {
          'ordermodeid': this.ordermodeid,
          'ordermodename': this.ordermodeform.get('ordermodename').value,
          'pricetypeid': this.ordermodeform.get('pricetypeid').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'inactive': this.ordermodeform.get('inactive').value,
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
        }
      
        this.appService.fnCheckOrdermode(data).subscribe(
          (res) => {
            //console.log(res)
            var _checkresult = res.json().result[0].checkfield;

            if (_checkresult === "done") {
              if (this.ordermodeform.get('ordermodeid').value > 0) {
                //Update Department
                this.fnSetOrdermode(data);
              }
              else {
                //Insert Department
                this.fnInsertOrdermode(data);
              }
            }
            else {
              if (_checkresult === "name") {
                this.saveloading=false
                this.ordermodeform.controls['ordermodename'].setErrors({ 'notfound': true });
              }
            }
          },
          (err) => {
            this.saveloading=false

            this.toastr.error('Error', err);
          });
      }
    } catch (ex) {
      this.saveloading=false

      this.fnShowErrorMsg(ex);
    }
  }

  //Insert
  fnInsertOrdermode(data) {

    this.appService.fnInsertOrdermode(data).subscribe(
      (res) => {
        this.saveloading=false

        if (res.json().result != "") {
          this.toastr.success('', "The New Ordermode has been added successfully.Insert Successfully");

          this.fnInsertActivityLog('INSERT', 0, data.ordermodeid);

          this.emitData.emit(this.ordermodeid);
          this.activeModal.close(true);
        }
      },
      (err) => {
        this.saveloading=false

        this.toastr.error('Error', err);
      });

  }

  //Set
  fnSetOrdermode(data) {

    this.appService.fnSetOrdermode(data).subscribe(
      (res) => {
        this.saveloading=false

        if (res.json().result != "") {
          this.toastr.success('', "The Ordermode has been updated successfully.");

          this.fnInsertActivityLog('EDIT', this.ordermodeid, data.ordermodename);

          this.emitData.emit(this.ordermodeid);
          this.activeModal.close(true);
        }
      },
      (err) => {
        this.saveloading=false

        this.toastr.error('Error', err);
      });

  }



  private fnEditMode(deptBO) {

    this.ordermodeform.setValue({

      ordermodeid: deptBO.ordermodeid,
      ordermodename: deptBO.ordermodename,
      pricetypeid: deptBO.pricetypeid,
      inactive: deptBO.inactive,
    });

    this.isaddmode = false;
    this.iseditmode = true;
    this.isdeletemode = false;
    this.isviewmode = false;
  }



  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
        'companyid': this.loginService.fnGetCompanyId(),

      }


       this.appService.fnInsertActivity(data).subscribe(
         (res)=>{
         },
         (err)=>{

         });

    } catch {

    }
  }



  public decline() {
    this.activeModal.close(false);
  }



  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }





}
